import axiosIns from '@/libs/axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getIntesaAccounts() {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('getIntesaAccounts')
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    getIntesaReportData(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('getIntesaReportData', queryParams)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    checkIntesaCustodies(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('checkIntesaCustodies', queryParams)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    downloadIntesaReportCsv(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('downloadIntesaReportCsv', queryParams, { responseType: 'blob' })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
